import { useState, useEffect } from 'react'
import dayjs from 'dayjs'

interface Props {
  minMs: number
  maxMs: number
}

/**
 * Glassmorphic vertical bar + time pill that tracks the current time
 * across the MuhurtaTimeline. Updates every minute.
 */
export function CurrentTimeIndicator({ minMs, maxMs }: Props) {
  const [nowMs, setNowMs] = useState(() => Date.now())

  useEffect(() => {
    const interval = setInterval(() => setNowMs(Date.now()), 60_000)
    return () => clearInterval(interval)
  }, [])

  if (nowMs < minMs || nowMs > maxMs) return null

  const pct = ((nowMs - minMs) / (maxMs - minMs)) * 100

  return (
    <div
      className="absolute top-0 bottom-0 z-10 pointer-events-none"
      style={{ left: `${pct}%` }}
    >
      {/* Vertical glow line */}
      <div className="absolute inset-y-0 left-0 w-px bg-amber-400/70" style={{ boxShadow: '0 0 6px rgba(251,191,36,0.5)' }} />
      {/* Time pill */}
      <div className="absolute -top-6 left-1/2 -translate-x-1/2 backdrop-blur-xl bg-white/10 ring-1 ring-amber-400/30 rounded-full px-2 py-0.5 whitespace-nowrap">
        <span className="text-amber-400 text-2xs font-mono tabular-nums">
          {dayjs(nowMs).format('HH:mm')}
        </span>
      </div>
    </div>
  )
}
